import Logo from "@/components/tpr/Logo/Logo";
import TprIcon from "@/components/tpr/TprIcon/TprIcon";
import { Button } from "@/components/ui/button";
import { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot } from "@/components/ui/input-otp";
import { REGEXP_ONLY_DIGITS } from "input-otp";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";

const Mfa = () => {
  const [code, setCode] = useState<number | undefined>(undefined);
  const [countdown, setCountdown] = useState(60);
  const [, setDisabled] = useState(false);
  const [badCode, setBadCode] = useState(false);

  let navigate = useNavigate();
  let location = useLocation();
  let from = location.state?.from?.pathname || "/dashboard";

  useEffect(() => {
    if (countdown === 0) return;
    const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  useEffect(() => {
    if (badCode) {
      const timer = setTimeout(() => setBadCode(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [badCode]);

  const handleResendCode = () => {
    if (countdown === 0) {
      // Logic to resend the code goes here
      setCountdown(60); // Reset countdown after resending code
    }
  };

  const renderBadCode = () => {
    return (
      <>
        <div className="flex justify-center items-center mx-auto">
          <div
            className="mt-8 p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800"
            role="alert"
          >
            Invalid code.
          </div>
        </div>
      </>
    );
  };

  const handleOTPChange = (value: string) => {
    // Convert to number if possible, otherwise undefined
    setCode(value && /^\d+$/.test(value) ? Number(value) : undefined);
  };

  const handleSubmit = (code: string) => {
    setDisabled(true);
    // Logic to verify the code goes here
    console.log("Submitted code:", code);

    if (parseInt(code.toString()) !== 888888) {
      setBadCode(true);
      setCode(undefined);
      return false;
    }

    // On successful verification, navigate to the main app (e.g., dashboard)
    navigate(from, { replace: true });
  };

  return (
    <div>
      <div className="bg-white dark:bg-gray-900">
        <div className="flex justify-center h-screen overflow-hidden">
          <div
            className="hidden bg-cover lg:block lg:w-2/3"
            style={{
              backgroundImage: `url("https://hopskotch.s3.eu-west-2.amazonaws.com/splashback/PhotoReal_abstract_pastel_oil_painting_sea_splash_sharpen_line_1.jpg")`,
              backgroundPosition: "50% 50%",
            }}
          ></div>

          <div className="flex items-center w-full max-w-md px-6 mx-auto lg:w-3/6">
            <div className="flex-1">
              <div className="text-center flex flex-col justify-center items-center">
                <div className="mb-4">
                  <TprIcon size="large" />
                </div>
                <h2 className="text-4xl font-bold text-center text-gray-700 dark:text-white">
                  <Logo color="black" size="large" />
                </h2>

                <p className="mt-3 text-gray-500 dark:text-gray-300">
                  Please enter the code we have sent to your email to complete your login.
                </p>
              </div>

              <div>{badCode && renderBadCode()}</div>

              <div className="mt-8 flex flex-col justify-center items-center">
                <InputOTP
                  maxLength={6}
                  pattern={REGEXP_ONLY_DIGITS}
                  onComplete={handleSubmit}
                  onChange={handleOTPChange}
                  value={code?.toString() || ""}
                >
                  <InputOTPGroup>
                    <InputOTPSlot index={0} autoFocus tabIndex={0} className="text-2xl" />
                    <InputOTPSlot index={1} className="text-2xl" />
                    <InputOTPSlot index={2} className="text-2xl" />
                  </InputOTPGroup>
                  <InputOTPSeparator />
                  <InputOTPGroup>
                    <InputOTPSlot index={3} className="text-2xl" />
                    <InputOTPSlot index={4} className="text-2xl" />
                    <InputOTPSlot index={5} className="text-2xl" />
                  </InputOTPGroup>
                </InputOTP>
              </div>

              <div className="mt-8 flex flex-col justify-center items-center gap-2">
                <Button
                  variant="link"
                  onClick={handleResendCode}
                  className={`text-sm text-blue-800 hover:underline hover:text-blue-900 ${
                    countdown > 0 ? "pointer-events-none opacity-50" : ""
                  }`}
                  aria-disabled={countdown > 0}
                >
                  {countdown > 0 ? `Resend code in ${countdown}s` : "Resend code"}
                </Button>
                {/* <a href="/mfa-alternative" className="text-sm text-blue-800 hover:underline hover:text-blue-900">
                  Login another way
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Mfa;
